import React, { useEffect, useState } from "react";
import Vendor101 from "../Components/Vendor101";
import Vendor102 from "../Components/Vendor102";
import Vendor103 from "../Components/Vendor103";
import ErrorScreen from "../Components/ErrorScreen"; // Optional
import { BrowserRouter } from "react-router-dom"; // Added

const UseCaseHandler = () => {
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("vendor_id");

    if (params.has("vendor_id")) {
      if (id) setVendorId(String(id));
    } else {
      setVendorId("101");
    }
  }, []);

  const renderVendor = () => {
    if (!vendorId) return null;

    switch (vendorId) {
      case "101":
        return <Vendor101 />;
      case "102":
        return <Vendor102 />;
      case "103":
        // Wrap Vendor103 in BrowserRouter since it uses useLocation
        return (
          <BrowserRouter>
            <Vendor103 />
          </BrowserRouter>
        );
      default:
        return <Vendor101 />;
    }
  };

  return renderVendor();
};

export default UseCaseHandler;
